import { useMutation } from '@apollo/client';
import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { Button, theme } from '@landsbankinn/ui';
import { LandsbankinnContext } from '@landsbankinn/utils';
import React, { useContext, useState } from 'react';
import { SmartBookingCustomerType } from '../../../../../__generated__/globalTypes';
import type {
  BookAppointment,
  BookAppointmentVariables,
  BookAppointment_bookAppointment_BookAppointmentPayload,
} from '../../../../graphql/Appointment/__generated__/BookAppointment';
import { BOOK_APPOINTMENT } from '../../../../graphql/Appointment/bookAppointment';
import {
  AppointmentStep,
  useAppointmentContext,
} from '../../../book-appointment/BookAppointment';
import { FormContainer } from '../../../book-appointment/shared/FormContainer';
import { CompanyInfo } from './CompanyInfo/CompanyInfo';
import res from './CustomerInfo.res';
import { PersonInfo } from './PersonInfo/PersonInfo';

const StyledButton = styled(Button)`
  width: 100%;
`;

interface IProps {
  setSuccessData: React.Dispatch<
    React.SetStateAction<
      BookAppointment_bookAppointment_BookAppointmentPayload | undefined
    >
  >;
}

export function CustomerInfo({ setSuccessData }: IProps) {
  const { state, setCurrentStep } = useAppointmentContext();
  const { r } = useResource();
  const { client } = useContext(LandsbankinnContext);
  const { locale } = useResource();
  const [kennitalaNotFound, setKennitalaNotFound] = useState(false);

  const [bookAppointment, { loading }] = useMutation<
    BookAppointment,
    BookAppointmentVariables
  >(BOOK_APPOINTMENT, {
    client,
    onCompleted: (data) => {
      if (data.bookAppointment.__typename === 'BookAppointmentPayload') {
        setSuccessData(data.bookAppointment);
        setCurrentStep?.(AppointmentStep.Success);
      }
      if (data.bookAppointment.__typename === 'KennitalaNotFoundError') {
        setKennitalaNotFound(true);
      }
    },
    context: {
      headers: {
        'Accept-Language': locale === 'is' ? 'is' : 'en-GB',
      },
    },
  });

  return (
    <FormContainer
      onBack={() => setCurrentStep?.(AppointmentStep.SelectDateAndTime)}
      onSubmit={() => {
        bookAppointment({
          variables: {
            data:
              state.customerType === SmartBookingCustomerType.Company
                ? ({
                    comment: state.note,
                    reservationId: state.reserveAppointmentId,
                    company: state.companyInfo,
                  } as any)
                : ({
                    comment: state.note,
                    customer: state.customerInfo,
                    reservationId: state.reserveAppointmentId,
                  } as any),
          },
        });
      }}
    >
      <>
        {state.customerType === SmartBookingCustomerType.Company && (
          <CompanyInfo />
        )}
        {state.customerType === SmartBookingCustomerType.Person && (
          <PersonInfo
            kennitalaNotFound={kennitalaNotFound}
            setKennitalaNotFound={setKennitalaNotFound}
          />
        )}

        <StyledButton
          type="submit"
          title={r(res.submit)}
          loading={loading}
          bg={theme.colors.primary}
        />
      </>
    </FormContainer>
  );
}
